/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  StatusFragmentDoc,
  CategoryFragmentDoc,
} from "../app/ProjectLabels.generated";
import { HexRowOptionsMenuFragmentDoc } from "./HexRowOptionsMenu.generated";
import { HexPermissionSummaryFragmentDoc } from "../hex/HexPermissionSummary.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HexAnalyticsFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly totalViewCount: number;
  readonly projectAnalytics: {
    readonly __typename: "HexAnalytics";
    readonly id: c.HexAnalyticsId;
    readonly totalViewsLast7Days: number;
    readonly totalViewsLast14Days: number;
    readonly totalViewsLast30Days: number;
  };
};

export type HexRowLastPublishedVersionFragment = {
  readonly __typename: "HexVersion";
  readonly id: c.HexVersionId;
};

export type HexRowCurrentDraftFragment = {
  readonly __typename: "HexVersion";
  readonly id: c.HexVersionId;
  readonly canEdit: boolean;
  readonly denialReason:
    | {
        readonly __typename: "AssetAccess";
        readonly hasAccessToSharedDataConnections: boolean;
        readonly hasAccessToSharedFiles: boolean;
        readonly hasAccessToSharedPackages: boolean;
        readonly hasAccessToSharedSecrets: boolean;
        readonly hasAccessToSharedSyncRepositories: boolean;
      }
    | { readonly __typename: "MissingProjectRole" }
    | null;
};

export type HexRowFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly title: string;
  readonly description: c.RichTextDocument | null;
  readonly canShare: boolean;
  readonly maxGrantableRole: Types.ProjectRole | null;
  readonly canViewLogic: boolean;
  readonly effectiveRole: Types.ProjectRole | null;
  readonly trashDate: c.DateTimeString | null;
  readonly starredByViewer: boolean;
  readonly userUpdatedDate: c.DateTimeString;
  readonly hexType: Types.HexType;
  readonly projectLanguage: Types.ProjectLanguage;
  readonly canDelete: boolean;
  readonly canSetOwner: boolean;
  readonly canEdit: boolean;
  readonly canEditorsShare: boolean;
  readonly archivedDate: c.DateTimeString | null;
  readonly unarchivedDate: c.DateTimeString | null;
  readonly publicRoleV2: Types.ProjectRole | null;
  readonly organizationRoleV2: Types.ProjectRole | null;
  readonly grantSummary: c.ProjectGrantSummary;
  readonly onlyGrantedToCurrentUser: boolean;
  readonly totalViewCount: number;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
    readonly name: string;
    readonly color: Types.HexColor;
    readonly description: string | null;
    readonly inLibrary: boolean;
    readonly endorsed: boolean;
    readonly icon: Types.IconType | null;
  } | null;
  readonly categories: ReadonlyArray<{
    readonly __typename: "Category";
    readonly id: c.CategoryId;
    readonly name: string;
    readonly color: Types.HexColor;
    readonly description: string | null;
  }>;
  readonly lastPublishedVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
  } | null;
  readonly currentDraft: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly title: string;
    readonly logicSessionId: c.AppSessionId;
    readonly canEdit: boolean;
    readonly oAuthSettings: {
      readonly __typename: "HexVersionOAuthSettings";
      readonly id: c.HexVersionOAuthSettingsId;
      readonly logicViewTokenShared: boolean;
    } | null;
    readonly denialReason:
      | {
          readonly __typename: "AssetAccess";
          readonly hasAccessToSharedDataConnections: boolean;
          readonly hasAccessToSharedFiles: boolean;
          readonly hasAccessToSharedPackages: boolean;
          readonly hasAccessToSharedSecrets: boolean;
          readonly hasAccessToSharedSyncRepositories: boolean;
        }
      | { readonly __typename: "MissingProjectRole" }
      | null;
  };
  readonly creator: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly owner: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly allowPublicSharing: boolean;
    readonly resolvedAllowPublicSharing: boolean;
  };
  readonly projectAnalytics: {
    readonly __typename: "HexAnalytics";
    readonly id: c.HexAnalyticsId;
    readonly totalViewsLast7Days: number;
    readonly totalViewsLast14Days: number;
    readonly totalViewsLast30Days: number;
  };
};

export type UpdateHexVersionCategoryMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  categoryId: Types.Scalars["CategoryId"]["input"];
  added: Types.Scalars["Boolean"]["input"];
}>;

export type UpdateHexVersionCategoryMutation = {
  readonly __typename: "Mutation";
  readonly updateHexVersionCategory: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
    }>;
  };
};

export type UpdateHexVersionStatusMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  statusId: Types.InputMaybe<Types.Scalars["StatusId"]["input"]>;
}>;

export type UpdateHexVersionStatusMutation = {
  readonly __typename: "Mutation";
  readonly updateHexVersionStatus: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
    } | null;
  };
};

export const HexRowLastPublishedVersionFragmentDoc = /*#__PURE__*/ gql`
  fragment HexRowLastPublishedVersionFragment on HexVersion {
    id
  }
`;
export const HexRowCurrentDraftFragmentDoc = /*#__PURE__*/ gql`
  fragment HexRowCurrentDraftFragment on HexVersion {
    id
    canEdit
    denialReason {
      ... on AssetAccess {
        hasAccessToSharedDataConnections
        hasAccessToSharedFiles
        hasAccessToSharedPackages
        hasAccessToSharedSecrets
        hasAccessToSharedSyncRepositories
      }
    }
  }
`;
export const HexAnalyticsFragmentDoc = /*#__PURE__*/ gql`
  fragment HexAnalyticsFragment on Hex {
    id
    totalViewCount
    projectAnalytics {
      id
      totalViewsLast7Days
      totalViewsLast14Days
      totalViewsLast30Days
    }
  }
`;
export const HexRowFragmentDoc = /*#__PURE__*/ gql`
  fragment HexRowFragment on Hex {
    id
    title
    description
    canShare
    maxGrantableRole
    canViewLogic
    effectiveRole
    trashDate
    starredByViewer
    userUpdatedDate
    hexType
    status {
      ...StatusFragment
    }
    categories {
      ...CategoryFragment
    }
    lastPublishedVersion {
      ...HexRowLastPublishedVersionFragment
    }
    currentDraft {
      ...HexRowCurrentDraftFragment
    }
    creator {
      id
      name
      email
    }
    ...HexRowOptionsMenuFragment
    ...HexPermissionSummaryFragment
    ...HexAnalyticsFragment
  }
  ${StatusFragmentDoc}
  ${CategoryFragmentDoc}
  ${HexRowLastPublishedVersionFragmentDoc}
  ${HexRowCurrentDraftFragmentDoc}
  ${HexRowOptionsMenuFragmentDoc}
  ${HexPermissionSummaryFragmentDoc}
  ${HexAnalyticsFragmentDoc}
`;
export const UpdateHexVersionCategoryDocument = /*#__PURE__*/ gql`
  mutation UpdateHexVersionCategory(
    $hexVersionId: HexVersionId!
    $categoryId: CategoryId!
    $added: Boolean!
  ) {
    updateHexVersionCategory(
      hexVersionId: $hexVersionId
      categoryId: $categoryId
      added: $added
    ) {
      id
      categories {
        id
      }
    }
  }
`;
export type UpdateHexVersionCategoryMutationFn = Apollo.MutationFunction<
  UpdateHexVersionCategoryMutation,
  UpdateHexVersionCategoryMutationVariables
>;

/**
 * __useUpdateHexVersionCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateHexVersionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHexVersionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHexVersionCategoryMutation, { data, loading, error }] = useUpdateHexVersionCategoryMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      categoryId: // value for 'categoryId'
 *      added: // value for 'added'
 *   },
 * });
 */
export function useUpdateHexVersionCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHexVersionCategoryMutation,
    UpdateHexVersionCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHexVersionCategoryMutation,
    UpdateHexVersionCategoryMutationVariables
  >(UpdateHexVersionCategoryDocument, options);
}
export type UpdateHexVersionCategoryMutationHookResult = ReturnType<
  typeof useUpdateHexVersionCategoryMutation
>;
export type UpdateHexVersionCategoryMutationResult =
  Apollo.MutationResult<UpdateHexVersionCategoryMutation>;
export type UpdateHexVersionCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateHexVersionCategoryMutation,
    UpdateHexVersionCategoryMutationVariables
  >;
export const UpdateHexVersionStatusDocument = /*#__PURE__*/ gql`
  mutation UpdateHexVersionStatus(
    $hexVersionId: HexVersionId!
    $statusId: StatusId
  ) {
    updateHexVersionStatus(hexVersionId: $hexVersionId, statusId: $statusId) {
      id
      status {
        id
      }
    }
  }
`;
export type UpdateHexVersionStatusMutationFn = Apollo.MutationFunction<
  UpdateHexVersionStatusMutation,
  UpdateHexVersionStatusMutationVariables
>;

/**
 * __useUpdateHexVersionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateHexVersionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHexVersionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHexVersionStatusMutation, { data, loading, error }] = useUpdateHexVersionStatusMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useUpdateHexVersionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHexVersionStatusMutation,
    UpdateHexVersionStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateHexVersionStatusMutation,
    UpdateHexVersionStatusMutationVariables
  >(UpdateHexVersionStatusDocument, options);
}
export type UpdateHexVersionStatusMutationHookResult = ReturnType<
  typeof useUpdateHexVersionStatusMutation
>;
export type UpdateHexVersionStatusMutationResult =
  Apollo.MutationResult<UpdateHexVersionStatusMutation>;
export type UpdateHexVersionStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateHexVersionStatusMutation,
  UpdateHexVersionStatusMutationVariables
>;
